// extracted by mini-css-extract-plugin
export default {"footerRow":"footerRow--mTW5u","footerColumnWidgetArea":"footerColumnWidgetArea--nKxyK"};